import React from "react";
import { Button, InputNumber, Space } from "antd";

const getRangeFilterProps = (dataIndex) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
    close,
  }) => (
    <div
      style={{
        padding: 8,
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <InputNumber
          placeholder="From"
          value={selectedKeys[0]?.from}
          onChange={(e) => setSelectedKeys([{ ...selectedKeys[0], from: e }])}
          onPressEnter={() => {
            confirm({
              closeDropdown: true,
            });
          }}
          style={{
            marginBottom: 8,
            display: "block",
            width: "130px",
          }}
        />
        <InputNumber
          placeholder={`To`}
          value={selectedKeys[0]?.to}
          onChange={(e) => setSelectedKeys([{ ...selectedKeys[0], to: e }])}
          onPressEnter={() => {
            confirm({
              closeDropdown: true,
            });
          }}
          style={{ marginBottom: 8, display: "block", width: "130px" }}
        />
      </div>
      <Space>
        <Button
          type="primary"
          onClick={() => {
            confirm({
              closeDropdown: true,
            });
          }}
          size="small"
          style={{
            width: 90,
          }}
        >
          Search
        </Button>
        <Button
          onClick={clearFilters}
          size="small"
          style={{
            width: 90,
          }}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            confirm({
              closeDropdown: false,
            });
          }}
        >
          Filter
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close();
          }}
        >
          close
        </Button>
      </Space>
    </div>
  ),
  onFilter: (value, record) => {
    const { from, to } = value;
    // Support nested values like 'item.value' in dataIndex
    let recordValue;
    if (Array.isArray(dataIndex)) {
      // When dataIndex is an array (e.g., ['item', 'value'])
      recordValue = dataIndex.reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        record
      );
    } else if (typeof dataIndex === "string" && dataIndex.includes(".")) {
      // When dataIndex is a dot string (e.g., 'item.value')
      recordValue = dataIndex
        .split(".")
        .reduce(
          (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
          record
        );
    } else {
      // Simple value
      recordValue = record[dataIndex];
    }
    recordValue = parseFloat(recordValue);
    if (!isNaN(from) && !isNaN(to)) {
      return recordValue >= from && recordValue <= to;
    } else if (!isNaN(from)) {
      return recordValue >= from;
    } else if (!isNaN(to)) {
      return recordValue <= to;
    }

    return true;
  },
});

export default getRangeFilterProps;
